var map = {
	"./address.js": "41e8",
	"./bank-account.js": "8968",
	"./bills.js": "dc5e",
	"./categories.js": "7c22",
	"./certificates.js": "5653",
	"./color.js": "5f75",
	"./commissions.js": "1f91",
	"./contact.js": "48c6",
	"./content.js": "412e",
	"./customer.js": "a70e",
	"./dashboard.js": "d748",
	"./email.js": "810f",
	"./files.js": "bf9b",
	"./forget-password.js": "4212",
	"./help-center.js": "e991",
	"./index.js": "32bb",
	"./integrations.js": "43af",
	"./landing-page.js": "2407",
	"./leads.js": "575c",
	"./loading.js": "afe8",
	"./login.js": "8cc5",
	"./mails.js": "ddbd",
	"./modules.js": "4859",
	"./not-found.js": "98db",
	"./plan-proposal.js": "4ef1",
	"./reseller.js": "70da",
	"./reset-password.js": "11bc",
	"./roles.js": "c65f",
	"./users.js": "98a5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "445b";